<template>
    <framed-layout>

        <template #center>
            <h3 class="font-bold">Esita lisatöö</h3>
        </template>

      <template #right>
          <a class="btn-circle cursor-pointer" @click="$router.go(-1)">
            <i class="text-xl text-blue-500 pi pi-times"></i>
          </a>
      </template>

        <div class="max-w-xl mx-auto mt-0 md:mt-16">
            <div>
                <div class="mb-10">
                    <h4 class="text-sm text-blue-500 uppercase">Lisatöö summa</h4>

                    <div class="relative">
                        <input-number
                            placeholder=" "
                            v-model="task.amount"
                            :use-grouping="false"
                            currency="EUR"
                            class="w-full"
                        />
                        <div>€</div>
                    </div>
                </div>

                <div class="mb-8">
                    <h4 class="text-sm text-blue-500 uppercase">Etapp</h4>

                    <dropdown
                        v-model="phase"
                        :options="phases"
                        option-label="name"
                        class="w-full text-gray-900"
                    />
                </div>

                <div class="mb-8" v-if="this.phase">
                  <h4 class="text-sm text-blue-500 uppercase">Ülesanne</h4>

                  <dropdown
                      id="taskName"
                      v-model="task.recipe"
                      :options="recipes[this.phase.id]"
                      option-label="title"
                      class="w-full text-gray-900"
                  />
                </div>

                <div class="mb-8">
                    <div class="p-float-label">
                        <input-text
                            id="taskComment"
                            placeholder=" "
                            v-model="task.comment"
                            class="w-full"
                        />
                        <label for="taskComment" class="text-blue-500 uppercase">Lisa kommentaar</label>
                    </div>
                </div>
            </div>

            <div class="flex justify-center mt-12 md:mt-16">
                <button
                    @click="addTask"
                    :class="{ 'opacity-50 pointer-events-none': (!task.recipe || task.amount < 1) || !phase }"
                    class="w-full sm:w-72 text-white bg-orange-400 btn"
                >Esita lisatöö
                </button>
            </div>
        </div>
    </framed-layout>
</template>

<script>
import FramedLayout from './../Layouts/FramedLayout'
import {getAddTask, postAddTask} from '../store/task.api'

export default {
    components: {
        FramedLayout
    },
    data() {
        return {
            task: {
                amount: 0,
                area_phase_id: null,
                recipe: null,
                comment: null
            },
            phase: null,
            projectId: null,
            phaseId: null,
            phases: null,
            recipes: []
        }
    },
    async mounted() {
      await this.loadAddTask();
    },
    methods: {
        addTask() {
            const payload = {
                task: this.task
            };
            postAddTask(this.$route.params.projectUserId, payload).then(({ data }) => {
                this.processAxiosPositiveResponse(data);
                this.$router.push(`/project/${this.$route.params.projectUserId}/task/add/complete`);
            });
        },
        async loadAddTask() {
          const { data } = await getAddTask(this.$route.params.projectUserId);
          if (data) {
            if (data?.route) {
              await this.$router.push(data.route);
            } else {
              this.projectId = data?.projectId;
              this.phaseId = data?.phaseId;
              this.phases = data?.phases;

              data?.area_phase_recipes.some((obj) => {
                this.recipes[obj.phase_id] = obj.assignments;
              });

              this.phases.some((obj) => {
                if(obj.id === parseInt(this.$route.params.tabId)) {
                  this.phase = obj;
                }
              });
            }
          }
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .p-inputnumber {
        input {
            @apply w-full pr-16;
        }

        input, & + div {
            @apply text-4xl text-gray-900 font-semibold not-italic leading-none;

            @screen sm {
                @apply text-7xl;
            }
        }

        & + div {
            @apply absolute right-0;

            top: 50%;
            transform: translateY(-50%);
        }
    }
}
</style>
